import PropTypes from "prop-types";

// material-ui
import { Typography } from "@mui/material";

// project imports
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import { store } from "store";
import { useSelector } from "react-redux";
import { CommonPrivFilter } from "utils/Privileges";

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = ({ drawerToggle }) => {
  const state = store.getState();
  const isAccountsShow = state.common.isAccountsShow;
  const userDetail = useSelector((state) => state.common.userDetail);

  const predicate= (route)=>!route.ref?true:CommonPrivFilter(route.ref)?.canRead

  function filterMenu(menu) {
    return menu
      .map((item) => {
        // Check if current item matches
        const matches = predicate(item);
  
        // Recursively filter children (if any)
        let filteredChildren = [];
        if (item.children && Array.isArray(item.children)) {
          filteredChildren = filterMenu(item.children, predicate);
        }
  
        // Include item if it matches or has matching children
        if (matches && filteredChildren.length > 0) {
          return {
            ...item,
            children: filteredChildren.length > 0 ? filteredChildren : undefined,
          };
        }else if(matches){
        return item
        }
  
        return null; // Don't include this item
      })
      .filter(Boolean);
  }

  const menuData =
    userDetail?.prev && userDetail.prev.length > 0 ? userDetail.prev : menuItem;

  const navItems = filterMenu(menuData).map((item) => {
    // if (!isAccountsShow && item.id === "accounts") {
    //   return null; // Return null to exclude it from rendering
    // }
    switch (item.type) {
      case "group":
        return (
          <NavGroup key={item.id} item={item} drawerToggle={drawerToggle} />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return <>{navItems}</>;
};

export default MenuList;

MenuList.propTypes = {
  drawerToggle: PropTypes.any,
};